const Job = (props)=>
{
  const {company, index, value, setValue} = props;
  return (
    <button onClick={() => setValue(index)} className={`job-btn ${index === value && 'active-btn'}`}>
            {company}
    </button>);
}

export default Job;